import { useEffect } from "react";

export default function useVersionChecker() {
  useEffect(() => {
    const checkVersion = async () => {
      const res = await fetch("/version.json?v=" + Date.now());
      const json = await res.json();

      const currentVersion = localStorage.getItem("app_version");

      if (currentVersion && currentVersion !== json.version) {
        localStorage.setItem("app_version", json.version);

        // 🔥 Clear cache bằng cách thêm query để ép browser tải lại toàn bộ file
        window.location.href = window.location.pathname + "?v=" + Date.now();
      }

      if (!currentVersion) {
        localStorage.setItem("app_version", json.version);
      }
    };

    checkVersion();
  }, []);
}
